import { render, staticRenderFns } from "./BillOfProcessDetailInput.vue?vue&type=template&id=05a6a471&scoped=true&"
import script from "./BillOfProcessDetailInput.vue?vue&type=script&lang=js&"
export * from "./BillOfProcessDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./BillOfProcessDetailInput.vue?vue&type=style&index=0&id=05a6a471&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a6a471",
  null
  
)

export default component.exports